import { TPricingPlans } from '../S/pricing/types';

export const toTitleCase = (str: string): string => {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const replaceSpaceWithHyphen = (str: string): string => {
  return str.replace(/\s+/g, '-').toLowerCase();
};

export const removeTags = (str: string): string => {
  if (str === null || str === '') {
    return '';
  } else {
    str = str.toString();
  }
  return str.replace(/(<([^>]+)>)/gi, '');
};

export const removeCommas = (input: string) => {
  return Number(input.replace(/,/g, ''));
};

export const addCommasToNumber = (
  num: number | string | undefined,
  decimalPlaces = 2,
  localeString = 'en-IN'
): string => {
  if (num !== 0 && !num) return '';

  const numericValue = typeof num === 'string' ? parseFloat(num) : num;
  if (!isNaN(numericValue)) {
    const numberWithFixedDecimals = parseFloat(
      numericValue.toFixed(decimalPlaces)
    );
    return numberWithFixedDecimals.toLocaleString(localeString);
  }

  return num.toLocaleString(localeString);
};

export const urlformatter = (str: string): string => {
  str = str.replace(/&/g, 'and');
  str = str.replace(/\s+/g, '-').toLowerCase();
  return str.replace(/[^0-9a-zA-Z]+/g, '-');
};

export const getFormattedUrl = (str: string): string => {
  return urlformatter(replaceSpaceWithHyphen(str.toLowerCase().trim()));
};

export const sanitizeInput = (qString: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const map: any = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  };
  const reg = /[&<>"'/]/gi;
  return qString.replace(reg, (match) => map[match]) as string;
};

export const floorRoundOff = (amount: number): number => {
  return Math.floor(amount);
};

// for rounding off number eg: ~~2.7 = 2 or ~~1.2 = 1;

export const bitwiseRoundOff = (num: number): number => {
  return ~~num;
};

export const addQueryParamToURL = (
  url: string,
  param: string,
  value: string | undefined
): string => {
  if (!value) return url;
  const newURL = new URL(url);
  newURL.searchParams.set(param, value);
  return newURL.toString();
};

export const extractPlanWFromId = (
  planId: string[],
  planData: Record<string, TPricingPlans>
): Array<TPricingPlans> => {
  const data = [] as TPricingPlans[];

  if (!planData || Object.keys(planData).length === 0) {
    return data;
  }

  planId.forEach((id: string) => {
    const plan = planData[id];
    if (!plan) {
      console.warn(`Plan with id "${id}" not found in planData`);
      return;
    }
    data.push(plan);
  });

  return data;
};
